// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLPhoneNumberComponent__nowrap div[class*=jut__FieldMessage__error]{white-space:nowrap}", "",{"version":3,"sources":["webpack://./../common/modules-react/ml-components-common-react/MLPhoneNumberComponent/MLPhoneNumberComponent.module.scss"],"names":[],"mappings":"AAGI,0EACI,kBAAA","sourcesContent":["@import \"~@jutro/theme/assets/sass/helpers\";\n\n.nowrap {\n    div[class*='jut__FieldMessage__error'] {\n        white-space: nowrap;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nowrap": "app__MLPhoneNumberComponent__nowrap"
};
export default ___CSS_LOADER_EXPORT___;
